import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { Customer } from '../../types'
import AccountIcon from '../../assets/icons/account-icon.svg'
import { baseButtonTextWhiteBg } from '../../theme/custom-styles'

export const RegisteredCustomerItem = ({ customerData, handleSelectRegisteredCustomer }: { customerData: Customer; handleSelectRegisteredCustomer: (customerData: Customer) => void }) => {
  const { t } = useTranslation(['payments-to-review-management', 'common'])

  return (
    <div
      style={{ cursor: 'pointer', width: '100%' }}
      className="registered-bank-account-item-container"
      onClick={() => handleSelectRegisteredCustomer(customerData)}
    >
      <div className="left-content">
        <div className="icon-container">
          <img
            src={AccountIcon}
            alt="account-icon"
          />
        </div>
        <div className="bank-account-data-text">{customerData.registeredFullName}</div>
      </div>
      <div className="right-content">
        <Button
          fullWidth
          variant="text"
          sx={baseButtonTextWhiteBg}
          className="actions-bar-button-action"
          onClick={() => handleSelectRegisteredCustomer(customerData)}
        >
          <div className="actions-bar-button-action-text">{t('customerBanksAccountsModal.selectButton')}</div>
        </Button>
      </div>
    </div>
  )
}
